import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { ANNOUNCEMENTS_COMPONENT_CONSTS } from '@app/config/constants';
import { SubSink } from 'subsink';
import { AddAnnouncementComponent } from './add-announcement/add-announcement.component';
import { EditAnnouncementComponent } from './edit-announcement/edit-announcement.component';
import {
  AnnouncementMaintenanceService,
  IAnnouncements
} from '@app/services/admin/announcement-maintenance/announcement-maintenance.service';

enum AnnouncementType {
  Active = 'Active',
  Scheduled = 'Scheduled',
  Inactive = 'Expired'
}

@Component({
  selector: 'app-announcements',
  templateUrl: './announcements.component.html',
  styleUrls: ['./announcements.component.css']
})
export class AnnouncementsComponent implements OnInit {
  private subs: SubSink;

  announcementListData: IAnnouncements[] = [];

  consts = ANNOUNCEMENTS_COMPONENT_CONSTS;
  isAnnouncementAdded = false;
  isLoading = false;
  userPermission: any;

  constructor(
    public dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data,
    public announcementMaintenanceService: AnnouncementMaintenanceService
  ) {}

  ngOnInit(): void {
    this.userPermission = this.data.userPermission;
    this.subs = new SubSink();
    this.isLoading = true;
    this.subs.sink = this.announcementMaintenanceService.announcementList$.subscribe((result) => {
      if (result && result.announcement.length) {
        this.announcementListData = this.getSortedListByStartDate(result.announcement);
      }
      this.isLoading = false;
    });
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }

  getPermissionLevelName(permissionLevels: IAnnouncements) {
    if (permissionLevels.directReports) {
      return this.consts.PERMISSIONLEVEL.DIRECTREPORTS.lable;
    }
    if (permissionLevels.region && permissionLevels.region.length > 0) {
      return this.consts.PERMISSIONLEVEL.REGION.lable;
    }
    if (permissionLevels.department && permissionLevels.department.length > 0) {
      return this.consts.PERMISSIONLEVEL.DEPARTMENT.lable;
    }
    if (permissionLevels.allDXC) {
      return this.consts.PERMISSIONLEVEL.ALLDXC.lable;
    }
    if (permissionLevels.isManager) {
      return this.consts.PERMISSIONLEVEL.MANAGERS.lable;
    }
  }

  getStatus(startDate: Date, endDate: Date): AnnouncementType {
    let status: AnnouncementType;
    let currentDate = new Date();
    startDate = new Date(startDate);
    endDate = new Date(endDate);
    if (currentDate < startDate) {
      status = AnnouncementType.Scheduled;
    } else if (currentDate >= startDate && currentDate <= endDate) {
      status = AnnouncementType.Active;
    } else {
      status = AnnouncementType.Inactive;
    }
    return status;
  }

  deleteAnnouncement(index: number) {
    this.isAnnouncementAdded = false;
    this.announcementListData.splice(index, 1);
    this.saveAnnouncements();
  }

  editAnnouncement(announcement: IAnnouncements, index: number) {
    this.isAnnouncementAdded = false;
    const dialogRef = this.dialog.open(EditAnnouncementComponent, {
      data: {
        userPermission: this.userPermission,
        announcement: announcement,
        permissionLeaveName: this.getPermissionLevelName(announcement)
      },
      autoFocus: false,
      panelClass: 'announcements-dialog-container'
    });

    this.subs.sink = dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.isAnnouncementAdded = true;
        this.announcementListData[index] = result;
        this.announcementListData = this.getSortedListByStartDate(this.announcementListData);
        this.saveAnnouncements();
      }
    });
  }

  private saveAnnouncements(): void {
    this.announcementMaintenanceService.addAnnouncements({
      core_id: this.userPermission.coreId,
      announcement: this.announcementListData
    });
  }

  private getSortedListByStartDate(announcementListData: IAnnouncements[]): IAnnouncements[] {
    return announcementListData.sort((a, b) => new Date(a.startDate).getTime() - new Date(b.startDate).getTime());
  }

  createAnnouncement(): void {
    this.isAnnouncementAdded = false;
    const dialogRef = this.dialog.open(AddAnnouncementComponent, {
      data: { userPermission: this.userPermission, announcement: null },
      autoFocus: false,
      panelClass: 'announcements-dialog-container'
    });

    this.subs.sink = dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.isAnnouncementAdded = true;
        this.announcementListData = this.getSortedListByStartDate([...this.announcementListData, ...[result]]);
        this.saveAnnouncements();
      }
    });
  }
}
